export default "__VITE_ASSET__Xth_uE8F__"